// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"9d166a16","716":"3998d671"}[chunkId] + ".chunk.js";
};